import { all } from 'redux-saga/effects';
import authSaga from './auth';
import componentMasterSaga from './component-master';
import platformServicesMasterSaga from './platform-master';
import gatewayMasterSaga from './gateway-master';
import machineryManagementSaga from './machinery-management';
import otAssetSaga from './otAsset';
import servicesSaga from './services';
import parametersSaga from './parameters';
import BuildUseCaseSaga from './build-use-case';
import UserManagementSaga from './user-management';
import OntologyMasterSaga from './ontology-master';
import partManagementSaga from './part-management';
import FactoryManagementSaga from './factory-management';
import UserRoleSaga from './user-role';
import UserPasswordSaga from './profile';
import connectivityDashboardSaga from './connectivity-dashboard';
import notificationSaga from './notification';
import settingsSaga from './settings';
import digitalTwinSaga from './digital-twin';
import secretManagerSaga from './secret-manager';
import MaintenanceManagementSaga from './maintenance-management';
import UseCaseBuilderSaga from './usecase-management';

export default function* rootSaga() {
  yield all([
    authSaga(),
    componentMasterSaga(),
    platformServicesMasterSaga(),
    gatewayMasterSaga(),
    machineryManagementSaga(),
    otAssetSaga(),
    servicesSaga(),
    parametersSaga(),
    BuildUseCaseSaga(),
    UserManagementSaga(),
    OntologyMasterSaga(),
    partManagementSaga(),
    FactoryManagementSaga(),
    UserRoleSaga(),
    UserPasswordSaga(),    
    notificationSaga(),
    digitalTwinSaga(),
    connectivityDashboardSaga(),
    settingsSaga(),
    MaintenanceManagementSaga(),
    UseCaseBuilderSaga(),
    secretManagerSaga()
  ]);
}
